import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export const useHasPermission = (credentialId) => {
  const roleCredentials = useSelector((state) => state?.AuthenticatedUser?.user_role?.role_credential || []);

  const hasPermission = useMemo(() => {
    if (!credentialId || typeof credentialId !== 'string') {
      return false;
    }

    return roleCredentials.some((credential) => credential?.credential_id?.trim() === credentialId.trim()) || false;

  }, [roleCredentials, credentialId]);

  return hasPermission;
};